import {ComponentRef, Injectable} from '@angular/core';
import {SelectAuthorSingleComponent} from './select-author-single.component';
import {OverlayRef, Overlay} from '@angular/cdk/overlay';
import {ComponentPortal} from '@angular/cdk/portal';

@Injectable({
  providedIn: 'root'
})
export class SelectAuthorSingleService {

  private selectBookSingle: ComponentRef<SelectAuthorSingleComponent> | any;
  private overlayRef: OverlayRef;
  constructor(private overlay: Overlay) {}

  select(filters, selected) {
    return new Promise((resolve) => {
      this.overlayRef = this.overlay.create();
      this.selectBookSingle = this.overlayRef.attach(new ComponentPortal(SelectAuthorSingleComponent));
      this.selectBookSingle.instance.showSelectModel(filters, selected);
      this.selectBookSingle.instance.selectChange.subscribe((data) => {
        resolve(data);
      });
      this.selectBookSingle.instance.modelCancel.subscribe(() => {
        this.selectBookSingle.destroy();
        resolve(null);
      });
    });
  }
}
